import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WishlistItem } from "../../types/Wishlist";
import { Cart } from "../../types/Cartlist";
import { AddressInterface } from "../../types/Address";
import { Orders } from "../../types/Orders";

export interface user {
    userId: number
    firstName: string
    lastName: string
    email: string
    role: "admin" | "client" | "subclient"
    clientId?: number
    razorpayConnected: boolean
}

export interface globalvalues {
    openSideMenue: boolean
    activeMenue: string
    userDetails: user | null
    token: string
    isNeedtoShowConnectwithRazor: boolean
    wishlist: WishlistItem[] | null
    cartlist: Cart | null
    activeCartStep: number
    selectedDeliveryAddress: AddressInterface | null
    selectedBillingAddress: AddressInterface | null
    selectedOrder: Orders | null
    billingSameAsDelivery: boolean,


}


const initialState: globalvalues = {
    activeMenue: "Dashboard",
    openSideMenue: false,
    userDetails: null,
    token: "",
    isNeedtoShowConnectwithRazor: true,
    wishlist: [],
    cartlist: null,
    activeCartStep: 0,
    selectedDeliveryAddress: null,
    selectedBillingAddress: null,
    selectedOrder: null,
    billingSameAsDelivery: true,

}
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setActiveMenue(state, action: PayloadAction<string>) {
            state.activeMenue = action.payload
        },
        setOpenSideMenue(state, action: PayloadAction<boolean>) {
            console.log("Acion", action.payload)
            state.openSideMenue = action.payload
        },
        setUserDetails(state, action: PayloadAction<user | null>) {
            state.userDetails = action.payload
        },
        setToken(state, action: PayloadAction<string>) {
            state.token = action.payload
        },
        setIsNeedtoShowConnectwithRazor(state, action: PayloadAction<boolean>) {
            state.isNeedtoShowConnectwithRazor = action.payload
        },
        setWishList(state, action: PayloadAction<WishlistItem[] | null>) {
            state.wishlist = action.payload
        },
        setCartList(state, action: PayloadAction<Cart | null>) {
            state.cartlist = action.payload
        },
        setActiveCartStep(state, action: PayloadAction<number>) {
            state.activeCartStep = action.payload
        },
        setSelectedDeliveryAddress(state, action: PayloadAction<AddressInterface | null>) {
            state.selectedDeliveryAddress = action.payload
        },
        setSelectedBillingAddress(state, action: PayloadAction<AddressInterface | null>) {
            state.selectedBillingAddress = action.payload
        },
        setSelectedOrder(state, action: PayloadAction<Orders | null>) {
            state.selectedOrder = action.payload
        },
        setBillingSameAsDelivery: (state, action) => {
            state.billingSameAsDelivery = action.payload
        },

    }

})
export const { setActiveMenue, setOpenSideMenue, setUserDetails, setToken, setIsNeedtoShowConnectwithRazor, setWishList, setCartList, setActiveCartStep, setSelectedDeliveryAddress, setSelectedOrder, setSelectedBillingAddress, setBillingSameAsDelivery } = globalSlice.actions
export default globalSlice.reducer 